import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError, UnderReviewError } from 'src/shared/error';

import { getViewerSignature } from 'src/app/shared/api/signature';

import type { PetitionCommentsDataQuery, PetitionCommentsDataQueryVariables } from './api.graphql';
import { PetitionCommentsData } from './api.graphql';

export type Petition = NonNullable<PetitionCommentsDataQuery['petition']>;
export type PetitionCommentsPageData = {
	petition: Petition;
	hasSignedPetition: boolean;
};

export async function getPetitionCommentsPageData(
	utilityContext: UtilityContext,
	petitionSlug: string,
	userId: string | undefined,
): Promise<PetitionCommentsPageData> {
	const { gql } = utilityContext;

	const [{ data }, signature] = await Promise.all([
		gql.fetch<PetitionCommentsDataQuery, PetitionCommentsDataQueryVariables>({
			query: PetitionCommentsData,
			variables: {
				petitionSlugOrId: petitionSlug,
			},
			rejectOnError: true,
		}),
		userId ? getViewerSignature(petitionSlug, utilityContext) : undefined,
	]);

	if (!data?.petition) {
		throw new NotFoundError();
	}

	if (data.petition.status === 'UNDER_REVIEW' && !data.petition.viewerCanEdit) {
		throw new UnderReviewError();
	}

	return {
		petition: data.petition,
		hasSignedPetition: !!signature,
	};
}
